import { AxiosResponse } from 'axios';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfDemand, ModelOfVehicleItem } from '../../database';
import api from '../../services/api';

export const useDemandServiceListController = () => {
    const [demandsData, setDemandsData] = useState<ModelOfDemand[]>([]);
    const [loading, setLoading] = useState(true);
    const [saldoAbastecimentos, setSaldoAbastecimentos] = useState<string[]>([]);
     const [vehicleList, setVehicleList] = useState<ModelOfVehicleItem[]>([]);

    const { people } = useAuth();
    const { userAgencyId } = useAuth();
    const toast: any = useRef();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getDemandsOrderServices = () => {
        console.log('people: ', people);
        console.log('userAgencyId: ', userAgencyId);
        api.post(`demands/admin/${userAgencyId}`)
            .then(response => {
                console.log("data demandas:", response.data)
                setDemandsData(response.data);
                setLoading(false);
            })
            .catch((response: AxiosResponse<any>) => {
                console.log('erro: ', response.status);
                setLoading(false);
            });
    };

    useEffect(() => {
        getDemandsOrderServices();
        getVehicleListAgency();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [people]);

    const vehicles = vehicleList.map(vehicle => {
        return { label: vehicle.PLACA + " | " + vehicle.DESCRICAO, value: vehicle.ID };
    });

    const getVehicleListAgency = async () => {
        const response = await api.post(`get-vehicles`, { ORGAO: userAgencyId }).then((response) => {
            setVehicleList(response.data);
            setLoading(false);
        })
            .catch((response: AxiosResponse) => {
                console.log('erro: ', response.status);
                setLoading(false);
            });
    };

    return {
        getDemandListController: {
            getDemandsOrderServices,
            demandsData,
            loading,
            toast,
            saldoAbastecimentos,
            vehicles,
            
        },

        handleDemandListController: {
            setSaldoAbastecimentos,
        }


    };
};
